import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import "./SidebarMenu.css";
import { useNavigate } from "react-router-dom";
import { toggleMenu, useDefaultLoad } from "./userMenuModel";


const UserSidebarMenu = ({closeModal}) => {
  const navigate = useNavigate();

  const [menuData, setMenuData] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);
  const [loading, setLoading] = useState(false);
  const filter={action:'menu'}
 
  useDefaultLoad({filter,setMenuData, setLoading})
  return (
    <>
    <div className="sidebar-wrapper" >
    {loading ? (
        <>
          <div className="d-flex justify-content-center align-items-center">
            <span
              className="text-primary spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
              style={{ width: "2rem", height: "2rem" }}
            ></span>
          </div>
        </>
      ) : (
        <>       
        <div className="menu-section">
          {menuData.map((category) => (
            <React.Fragment key={category.id}>
              <div
                className="menu-item"
                onClick={() => toggleMenu(category.id,setOpenMenu,openMenu)}
                style={{ cursor: "pointer", userSelect: "none" }}
              >
                <div className="menu-label-wrapper" 
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize:'0.8rem' }}>
                  <span>{category.mpname}</span>
                  <span className="chevron" style={{ fontWeight: "bold", fontSize: "18px" }}>
                    {openMenu === category.id ? "▲" : "▼"}
                  </span>
                </div>
              </div>

              <Collapse in={openMenu === category.id}>
                <div className="submenu" style={{ paddingLeft: "15px" }}>
                  {category.subproducts.map((sub) => (
                    <div
                      key={sub.id}
                      className="submenu-item"
                      style={{ padding: "6px 0", cursor: "pointer",fontSize:'0.8rem' }}
                      onClick={() => {
                        // Navigate or handle click on subproduct
                        navigate(`/tbk/${sub.id}`);
                        closeModal();
                      }}
                    >
                      {sub.subpname}
                    </div>
                  ))}
                </div>
              </Collapse>
            </React.Fragment>
          ))}
        </div>         
        </>
      )
    }
    </div>  
    </>
  );
};

export default UserSidebarMenu;
